if (!customElements.get("ppd-quick-view")) {
  customElements.define(
    "ppd-quick-view",
    class PPDQuickView extends HTMLElement {
      constructor() {
        super();
        this.handleClickBound = this.handleClick.bind(this); // Store the bound function
      }

      connectedCallback() {
        // Add event listener to handle clicks on this specific instance
        this.addEventListener("click", this.handleClickBound);
      }

      disconnectedCallback() {
        // Remove event listener when element is removed from the DOM
        this.removeEventListener("click", this.handleClickBound);
      }

      handleClick(event) {
        // Check if the clicked element is the instance itself or a descendant with the class 'ppd-quick-view'
        if (
          event.target === this ||
          event.target.classList.contains("ppd-quick-view")
        ) {
          const QV_Button = this.querySelector("button");
          const QV_Spinner = this.querySelector(".loading__spinner");
          const QV_Handle = event.target
            .closest(".card-wrapper.product-card-wrapper")
            .querySelector("h3 > a");
          const QV_VariantID = event.target
            .closest(".card-wrapper.product-card-wrapper")
            .querySelector("input[name='id']");
          if (
            QV_Handle &&
            QV_Handle.pathname &&
            QV_Button &&
            QV_Spinner &&
            QV_VariantID &&
            QV_VariantID.value
          ) {
            const QV_ModalImageWidth = 500;
            if (!document.getElementById("QV_Modal")) {
              // Create modal container element
              const QV_ModalContainer = document.createElement("div");
              QV_ModalContainer.classList.add("modal", "fade");
              QV_ModalContainer.id = "QV_Modal";
              QV_ModalContainer.setAttribute("tabindex", "-1");
              QV_ModalContainer.setAttribute(
                "aria-labelledby",
                "QV_ModalLabel"
              );
              QV_ModalContainer.setAttribute("aria-hidden", "true");

              // Create modal dialog
              const QV_ModalDialog = document.createElement("div");
              QV_ModalDialog.classList.add(
                "modal-dialog",
                "modal-dialog-centered",
                "modal-xl"
              );

              // Create modal content
              const QV_ModalContent = document.createElement("div");
              QV_ModalContent.classList.add("modal-content", "p-2");

              // Modal Header
              const QV_ModalHeader = document.createElement("div");
              QV_ModalHeader.classList.add(
                "position-absolute",
                "top-0",
                "end-0",
                "p-2"
              );
              QV_ModalHeader.style.zIndex = 1;

              const QV_CloseButton = document.createElement("button");
              QV_CloseButton.setAttribute("type", "button");
              QV_CloseButton.classList.add("btn-close");
              QV_CloseButton.setAttribute("data-bs-dismiss", "modal");
              QV_CloseButton.setAttribute("aria-label", "Close");
              QV_CloseButton.style.cursor = "pointer";
              QV_ModalHeader.appendChild(QV_CloseButton);

              // Modal Body
              const QV_ModalBody = document.createElement("div");
              QV_ModalBody.classList.add("modal-body", "p4");

              // Modal Row
              const QV_ModalRow = document.createElement("div");
              QV_ModalRow.classList.add("row");

              const QV_ModalColFirst = document.createElement("div");
              QV_ModalColFirst.classList.add(
                "col-12",
                "col-lg-6",
                "mb-2",
                "d-flex",
                "align-items-center",
                "justify-content-center"
              );
              QV_ModalColFirst.style.maxHeight = `${QV_ModalImageWidth}px`;

              const QV_ModalColSecond = document.createElement("div");
              QV_ModalColSecond.classList.add("col-12", "col-lg-6");

              const QV_ModalImage = document.createElement("img");
              QV_ModalImage.classList.add("img-fluid");

              const QV_ModalTitle = document.createElement("h3");

              const QV_ModalPrice = document.createElement("div");
              QV_ModalPrice.classList.add("price");

              const QV_ModalPriceRegular = document.createElement("div");
              QV_ModalPriceRegular.classList.add("price__regular");

              const QV_ModalPriceSaleValue = document.createElement("span");
              QV_ModalPriceSaleValue.classList.add(
                "price-item",
                "price-item--sale"
              );

              const QV_ModalPriceRegularValue = document.createElement("span");
              QV_ModalPriceRegularValue.classList.add(
                "price-item",
                "price-item--regular"
              );

              const QV_ModalPriceSale = document.createElement("div");
              QV_ModalPriceSale.classList.add("price__sale");

              const QV_ModalDescription = document.createElement("div");
              QV_ModalDescription.classList.add(
                "qv-description",
                "fs-4",
                "lh-sm"
              );

              QV_ModalColFirst.appendChild(QV_ModalImage);
              QV_ModalColSecond.appendChild(QV_ModalTitle);
              QV_ModalPriceSale.appendChild(
                QV_ModalPriceRegularValue.cloneNode(true)
              );
              QV_ModalPriceSale.appendChild(QV_ModalPriceSaleValue);
              QV_ModalPriceRegular.appendChild(QV_ModalPriceRegularValue);
              QV_ModalPrice.appendChild(QV_ModalPriceRegular);
              QV_ModalPrice.appendChild(QV_ModalPriceSale);
              QV_ModalColSecond.appendChild(QV_ModalPrice);
              QV_ModalColSecond.appendChild(QV_ModalDescription);
              QV_ModalRow.appendChild(QV_ModalColFirst);
              QV_ModalRow.appendChild(QV_ModalColSecond);
              QV_ModalBody.appendChild(QV_ModalRow);

              // Modal Footer
              const QV_ModalFooter = document.createElement("div");
              QV_ModalFooter.classList.add("modal-footer");

              const QV_CloseButtonFooter = document.createElement("button");
              QV_CloseButtonFooter.setAttribute("type", "button");
              QV_CloseButtonFooter.classList.add("btn", "btn-secondary");
              QV_CloseButtonFooter.setAttribute("data-bs-dismiss", "modal");
              QV_CloseButtonFooter.textContent = "Close";

              // Append modal header, body
              QV_ModalContent.appendChild(QV_ModalHeader);
              QV_ModalContent.appendChild(QV_ModalBody);

              // Append modal content to dialog
              QV_ModalDialog.appendChild(QV_ModalContent);

              // Append modal dialog to container
              QV_ModalContainer.appendChild(QV_ModalDialog);

              // Append modal container to document body
              document.body.appendChild(QV_ModalContainer);
            }
            // JavaScript to handle modal

            const QV_ModalDom = document.getElementById("QV_Modal");
            const myModal = new bootstrap.Modal(QV_ModalDom);

            QV_Button.disabled = true;
            QV_Button.classList.add("loading");
            QV_Spinner.classList.remove("hidden");

            fetch(`${QV_Handle.pathname}.json`)
              .then((response) => {
                if (!response.ok) {
                  throw new Error(
                    "Product Quick View: Network response was not ok"
                  );
                }
                return response.json();
              })
              .then((data) => {
                // Handle successful response
                if (QV_ModalDom) {
                  const QV_ModalDomTitle = QV_ModalDom.querySelector("h3");
                  const QV_ModalDomImage = QV_ModalDom.querySelector("img");
                  const QV_ProductTitle = data.product.title;
                  const QV_ProductImage = data.product.image.src;
                  const QV_ProductVariants = data.product.variants;
                  const QV_ProductDescription = data.product.body_html; //qv-description
                  if (
                    QV_ModalDomTitle &&
                    QV_ModalDomImage &&
                    QV_ProductTitle &&
                    QV_ProductImage &&
                    QV_ProductVariants
                  ) {
                    QV_ModalDomTitle.innerText = QV_ProductTitle;
                    QV_ModalDomImage.src = `${QV_ProductImage}&width=${QV_ModalImageWidth}`;
                    QV_ProductVariants.forEach((e) => {
                      if (e["id"] == QV_VariantID.value) {
                        const QV_Productcompare_at_price =
                          e["compare_at_price"];
                        const QV_Productprice = e["price"];
                        if (QV_Productcompare_at_price > QV_Productprice) {
                          QV_ModalDom.querySelector(".price").classList.add(
                            "price--on-sale"
                          );
                        } else {
                          QV_ModalDom.querySelector(".price").classList.remove(
                            "price--on-sale"
                          );
                        }
                        if (QV_Productprice) {
                          QV_ModalDom.querySelector(
                            ".price__regular .price-item--regular"
                          ).innerText = `$${QV_Productprice}`;
                          QV_ModalDom.querySelector(
                            ".price__sale .price-item--sale"
                          ).innerText = `$${QV_Productprice}`;
                        }
                        if (QV_Productcompare_at_price) {
                          QV_ModalDom.querySelector(
                            ".price__sale .price-item--regular"
                          ).innerText = `$${QV_Productcompare_at_price}`;
                        }
                        QV_ModalDom.querySelector(".qv-description").innerHTML =
                          QV_ProductDescription;
                      }
                    });
                    myModal.show();
                  }
                }
              })
              .catch((error) => {
                // Handle error
                console.error(
                  "Product Quick View: There was a problem with the fetch operation:",
                  error
                );
              })
              .finally(() => {
                // Enable the button after request completion (whether success or failure)
                QV_Button.disabled = false;
                QV_Button.classList.remove("loading");
                QV_Spinner.classList.add("hidden");
              });
          }
        }
      }
    }
  );
}
